<template>
  <md-card>
    <div>
      <b-modal
        id="modal-reason"
        title="Сабаб"
        hide-footer
        size="xl"
        @shown="Shovedform('modal-reasonlist')"
        @hidden="Hidecreate()"
      >
        <form>
          <div class="row">
            <div class="col-md-4">
              <label>{{ $t("Номи") }}</label>
            </div>
            <div class="col-md-8">
              <input
                class="form-control"
                ref="inputText1"
                v-model="reasonnew.name"
                type="text"
              />
            </div>
            <div class="col-md-12 modal-footer">
              <hr />
              <button type="button" class="btn btn-primary" @click="Create()">
                {{ $t("Сақлаш") }}
              </button>
            </div>
          </div>
        </form>
      </b-modal>
      <b-modal
        id="modal-reasonset"
        title="Сабаб"
        hide-footer
        size="xl"
        @shown="Shovedform('modal-reasonlist')"
        @hidden="Hidecreate()"
      >
        <form>
          <div class="row">
            <div class="col-md-4">
              <label>{{ $t("Номи") }}</label>
            </div>
            <div class="col-md-8">
              <input
                class="form-control"
                ref="inputText1"
                v-model="reason.name"
                type="text"
              />
            </div>
            <div class="col-md-12 modal-footer">
              <hr />
              <button type="button" class="btn btn-primary" @click="Update()">
                {{ $t("Сақлаш") }}
              </button>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="modal-reasonlist"
        title="Сабаб"
        hide-footer
        size="xl"
        @shown="Shoved"
        @hidden="Hide()"
      >
        <div class="row">
          <div style="display:-webkit-inline-box">
            <button type="button" class="mybtn btn insert" v-b-modal.modal-reason>
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
            </button>
            <input
              type="text"
              class="form-control searchtable"
              v-bind:placeholder="$t('Қидирув')"
              v-model="filter"
              ref="inputText1"
            />
          </div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>№</th>
                <th>{{ $t("Номи") }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in filteredRows" :key="index">
              <tr>
                <span class="cursor" @click="
                Selected(item.id);
                $bvModal.hide('modal-reasonlist');
              ">
                <td>{{ index + 1 }}</td>
                <td>
                  <button
                    type="button"
                    class="atable"
                  >
                    {{ item.name }}
                  </button>
                </td>
                </span>
                <td>
                  <button
                    type="button"
                    class="mybtn btn"
                    @click="
                      reason = filteredRows[index];
                      sett = index;
                    "
                    v-b-modal.modal-reasonset
                  >
                    <b-icon icon="pencil"></b-icon><sup>(f2)</sup>
                  </button>
                  <button
                    type="button"
                    class="mybtn btn"
                    @click="Unittrash(item.id)"
                  >
                    <b-icon icon="trash"></b-icon><sup>(delete)</sup>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
  </md-card>
</template>
<script>
import $ from "jquery";
import { toggle } from "../../components/mixins/mymixin.js";
export default {
  name: "reason",
  mixins: [toggle],
  data() {
    return {
      focusset: "",
      filter: "",
      sett: null,
      reason: { name: "" },
      reasonnew: { name: "" },
      reasonlist: [],
      select: 0
    };
  },
  props: ["datas"],
  methods: {
    Unittrash(id) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        let self = this;
        axios({
          method: "delete",
          url: "api/v1/reason/id/" + id
        }).then(function(response) {
          self.Unitlist();
        });
      }
    },
    Unitlist() {
      let self = this;
      axios.get("api/v1/reason").then(function(response) {
        self.reasonlist = response.data;
        self.$root.$emit("reasonall", response.data);
      });
    },
    Selected(id) {
      // this.datas.reason_id=id;
    },
    Update() {
      let self = this;
      axios({
        method: "patch",
        url: "api/v1/reason/id/" + self.reason.id,
        data: self.reason
      }).then(function(response) {
        self.Unitlist();
        self.reason = { name: "" };
        self.$store.state.saved_modal = "updated";
        self.$bvModal.hide("modal-reasonset");
      });
    },
    Hidecreate() {
      if (this.$store.state.saved_modal == "create") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Create();
        } else {
          this.reasonnew = { name: "" };
          this.$root.$emit("reasonone", this.reasonnew);
        }
      } else if (this.$store.state.saved_modal == "update") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Update();
        }
      }
      this.$store.state.saved_modal = null;
      this.$bvModal.show("modal-reasonlist");
    },
    Create() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/reason",
        data: self.reasonnew
      }).then(function(response) {
        // self.reasonlist.push(response.data);
        var a = [];
        a.push(response.data);
        var b = a.concat(self.reasonlist);
        self.reasonlist = b;
        self.$root.$emit("reasonall", self.reasonlist);
        self.$store.state.saved_modal = "created";
        self.reasonnew = { name: "" };
        self.$bvModal.hide("modal-reason");
        self.sett = "create";
        self.$root.$emit("reasonone", self.reasonnew);
      });
    }
  },
  computed: {
    filteredRows() {
      return this.reasonlist.filter(row => {
        const name = row.name.toString().toLowerCase();
        const searchTerm = this.filter.toLowerCase();

        return name.includes(searchTerm);
      });
    }
  },
  watch: {
    reason: {
      deep: true,
      handler(val, oldVal) {
        if (this.$store.state.saved_modal == null) {
          this.$store.state.saved_modal = "update";
        }
      }
    },
    reasonnew: {
      deep: true,
      handler(val, oldVal) {
        if (val.name != "") {
          this.$store.state.saved_modal = "create";
        } else {
          this.$store.state.saved_modal = null;
        }
      }
    }
  },
  created() {
    this.$root.$emit("reasonone", this.reasonnew);
    this.$root.$emit("reasonselected", this.select);
    this.Unitlist();
  }
};
</script>
<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
}
</style>
